import type { User } from '@iheartjane/types';
import Moe from '@moengage/web-sdk';
import { useEffect } from 'react';

const identifyToMoengage = async (user?: Partial<User>) => {
  if (Moe.isMoeLoaded()) {
    const moeUserEmail = Moe.getUserIdentities()?.['u_em'];
    try {
      if (user?.email) {
        await Moe.identifyUser({
          uid: user.id?.toString() ?? '',
          u_em: user.email,
        });
        Moe.add_email(user.email);
        if (user.first_name) Moe.add_first_name(user.first_name);
        if (user.last_name) Moe.add_last_name(user.last_name);
        if (user.birth_date) Moe.add_birthday(new Date(user.birth_date));
        if (user.phone) Moe.add_mobile(user.phone);
      } else if (moeUserEmail) {
        Moe.destroy_session();
      }
    } catch (error) {
      console.error('Error identifying through Moengage', error);
    }
  }
};

export const useMoengageIdentify = (user?: Partial<User>) => {
  useEffect(() => {
    identifyToMoengage(user);
  }, [user]);
};
